<style lang="scss" scoped>
audio {
  max-width: 100%;
  width: 250px;
  height: 50px;
}
</style>
<template>
  <div class="flex-row flex-grow-1 pt-3 pb-4">
    <div class="border shadow rounded p-2 bg-white">
      <h4 class="text-primary">Sprachnachrichten</h4>
      <div class="d-flex flex-wrap">
        <div v-for="(audioMsg, index) in audio" :key="index" class="m-1">
          <audio
            class="p-1"
            :class="{ 'border border-danger': audioMsg.is_erotic }"
            :src="audioMsg.url"
            controls
          />
          <div class="d-flex">
            <div
              v-if="audioMsg.is_erotic"
              class="bg-danger ml-2 mb-2 pl-2 pr-2 text-white"
            >
              Erotisch
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["media"],
  computed: {
    audio() {
      return this.media.filter(media => media.is_audio);
    }
  }
};
</script>
